const MASKED_MOBILE = /[*xX]{2,}\d{2,4}/;

// ABDM answers an OTP request with text such as
// "OTP sent to Aadhaar registered mobile number ending with ******5852".
// Returns the masked number from it, or null when the text has none.
export function extractMaskedMobile(message: string | undefined): string | null {
  if (!message) {
    return null;
  }

  const match = MASKED_MOBILE.exec(message);
  return match ? match[0] : null;
}
